import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [{
    path: '/',
    component: resolve => require(['@/P13_DG/components/Home.vue'], resolve),
    children: [{
        //首页
        path: '/',
        name: "/",
        component: resolve => require(['@/P13_DG/components/Center.vue'], resolve),
    },
    {
        //二级页面
        path: '/cufa',
        component: resolve => require(['@/P13_DG/views/cufa.vue'], resolve),
        children: [
            // 联系我们
            {
                path: '/lianxiwomen.html',
                name: 'lianxiwomen',
                component: resolve => require(['@/P13_DG/views/Pages/lianxiwomen.vue'], resolve),
            },
            // 录取查询
            {
                path: '/luquchaxun.html',
                name: 'luquchaxun',
                component: resolve => require(['@/P13_DG/views/Pages/luquchaxun.vue'], resolve),
            },
            // 校园风景
            {
                path: "/xyfj/:id.html",
                name: 'xyfj',
                component: (resolve) =>
                    require(["@/P13_DG/views/Pages/xyfj.vue"], resolve),
            },
            {
                path: "/xyfj.html",
                name: 'xyfjs',
                redirect: "/xyfj/1.html",
            },
            // 留言咨询
            {
                path: '/liuyan.html',
                name: 'liuyan',
                component: resolve => require(['@/P13_DG/views/Pages/liuyan.vue'], resolve),
            },
            //招生简章
            {
                path: '/yingxiang.html',
                name: 'yingxiang',
                component: resolve => require(['@/P13_DG/views/Pages/yingxiang.vue'], resolve),
            },
            //影像制作
            {
                path: "/yingxiangzhizuoxue.html",
                name: 'yingxiangzhizuoxue',
                component: resolve => require(['@/P13_DG/views/Pages/yingxiangzhizuoxue.vue'], resolve),
            },
            // 院系介绍
            {
                path: '/schoolintroduction.html',
                name: 'schoolintroduction',
                component: resolve => require(['@/P13_DG/views/Pages/yuanxijieshao.vue'], resolve),
            },
            // 东国简介
            {
                path: '/introduction.html',
                name: 'introduction',
                component: resolve => require(['@/P13_DG/views/Pages/jianjie.vue'], resolve),
            },
            //东国概况
            {
                path: '/dongguogaikuang.html',
                name: 'dongguogaikuang',
                component: resolve => require(['@/P13_DG/views/Pages/dongguogaikuang.vue'], resolve),
            },
            // 教学阵容
            {
                path: '/jiaoxue.html',
                name: 'jiaoxue',
                component: resolve => require(['@/P13_DG/views/Pages/jiaoxuezhenrong.vue'], resolve),
            },
            //校园资讯列表
            {
                path: "/xiaoyuanzixun/:id.html",
                name: 'xiaoyuanzixun',
                component: (resolve) =>
                    require(["@/P13_DG/views/Pages/zixunFile/xiaoyuanzixun.vue"], resolve),
            },
            {
                path: "/xiaoyuanzixun.html",
                name: 'xiaoyuanzixuns',
                redirect: "/xiaoyuanzixun/1.html",
            },
            //海归政策资讯列表
            {
                path: "/haiguizhengce/:id.html",
                name: 'haiguizhengce',
                component: (resolve) =>
                    require(["@/P13_DG/views/Pages/zixunFile/haiguizhengce.vue"], resolve),
            },
            {
                path: "/haiguizhengce.html",
                name: 'haiguizhengces',
                redirect: "/haiguizhengce/1.html",
            },
            //资讯详情页面
            {
                path: "/listcontent/:id-:WebsiteContentId.html",
                name: 'listcontent',
                component: (resolve) =>
                    require([
                        "@/P13_DG/views/Pages/zixunFile/Listcontent.vue",
                    ], resolve),
            },
            //视频列表
            {
                path: "/videoList/:id.html",
                name: 'videoList',
                component: (resolve) =>
                    require(["@/P13_DG/views/Pages/videolist.vue"], resolve),
            },
            {
                path: "/videoList.html",
                name: 'videoLists',
                redirect: "/videoList/1.html",
            },
            //视频详情页面
            {
                path: "/videocontent/:id.html",
                name: 'videocontent',
                component: (resolve) =>
                    require([
                        "@/P13_DG/views/Pages/videocontent.vue",
                    ], resolve),
            },
            //知名校友列表页面
            {
                path: "/zhimingxiaoyou/:id.:html",
                name: 'zhimingxiaoyou',
                component: (resolve) =>
                    require(["@/P13_DG/views/Pages/zhimingxiaoyou.vue"], resolve),
            },
            {
                path: "/zhimingxiaoyou.html",
                name: 'zhimingxiaoyous',
                redirect: "/zhimingxiaoyou/1.html",
            },
            //留学解答 列表页面
            {
                path: "/application/:id.html",
                name: 'application',
                component: (resolve) =>
                    require(["@/P13_DG/views/Pages/zixunFile/application.vue"], resolve),
            },
            {
                path: "/application.html",
                name: 'applications',
                redirect: "/application/1.html",
            },
            // 东国资讯
            {
                path: '/dongguozixun.html',
                name: 'dongguozixun',
                component: resolve => require(['@/P13_DG/views/Pages/dongguozixun.vue'], resolve),
            },
            // 标签列表
            {
                path: "/biaoqianpage/:id-:lableName.:html",
                name: 'biaoqianpage',
                component: resolve => require(['@/P13_DG/views/Pages/biaoqianPage.vue'], resolve),
            },
            {
                path: "/biaoqianpage.html",
                name: "biaoqianpages",
                redirect: "/biaoqianpage/1.:html"
            },
            // 申请报名
            {
                path: '/shenqingbaoming.html',
                name: 'shenqingbaoming',
                component: resolve => require(['@/P13_DG/views/Pages/shenqingbaoming.vue'], resolve),
            },
        ]
    }
    ]
},
//404页面路由配置
{
    name: "404",
    path: "*",
    component: (resolve) =>
        require(["@/P13_DG/components/notfount.vue"], resolve),
},
    // {
    //     path: "*",
    //     redirect: {
    //         name: "/",
    //     },
    // },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})
// 动态切换title
// const _title = {
//   head_University: '我的名片',
//   MyApp: '联系我们',
//   qingxi: '联系我们',
//   hanliu: '联系我们',
//   home:'首页'
// }
// router.beforeEach((to, form,next) => {
//   window.document.title = _title[to.name];
//   next();
// })
export default router